import Slider from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import './slider.css'

const SimpleSlider = ({friends}) => {

      const settings = {
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            variableWidth: true,
            autoplay: true,
            autoplaySpeed: 4000,
            cssEase: 'ease-in-out',
            responsive: [
                  {
                    breakpoint: 1280,
                    settings: {
                      slidesToShow: 3,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 420,
                    settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1
                    }
                  },
                  {
                    breakpoint: 300,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1
                    }
                  }
            ]
      };

      return (
            <div>
                  <Slider {...settings}>
                        {
                              friends.map((item) => (
                                    <div className="friend_card tooltip" key={item.avatar}>
                                          <a href={item.me} target="_blank" rel="noreferrer" data-tooltip={item.name}>
                                                <div className="friend_card__img">
                                                      <img src={item.avatar} alt={item.name} />
                                                </div>
                                          </a>
                                    </div>
                              ))
                        }
                  </Slider>
            </div>
      )
}

export default SimpleSlider